export interface formParams {
  parentId?: string; // 父部门ID
  ancestors?: string; // 祖级列表
  deptName?: any; // 部门名称
  orderNum?: string; // 显示顺序
  leader?: string; // 负责人
  phone?: string; // 联系电话
  email?: string; // 邮箱
  status?: true; // 部门状态0正常,1停用
  delFlag?: string; // 删除标志（0代表存在 2代表删除）
  parentName?: string; // 父部门名称
  deptType: number; // 部门类型
  sectorId: number; // 板块id
  clientId?: number | null;
  children: [
    // 子部门
    {},
  ];
  remark?: string; // 备注
  kingdeeCode?: string; // 金蝶编码
}

export enum DeptStatus {
  '正常',
  '停用',
}

export function getDeptList(query: any) {
  return request({
    url: '/system/dept/listByXCCT',
    method: 'get',
    params: query,
  });
}
// 获取部门下拉树列表
export function getTreeSelect() {
  return request({
    url: '/system/dept/treeselect',
    method: 'get',
  });
}

// 新增组织
export function addDept(data: any) {
  return request({
    url: '/system/dept',
    method: 'post',
    data: data,
  });
}

// 根据部门编号获取详细信息`/building/zcBuildingCertificate/${id}`,
export function getDeptById(id: any) {
  return request({
    url: `/system/dept/${id}`,
    method: 'get',
  });
}

// 删除组织
export function delDept(deptId: any) {
  return request({
    url: '/system/dept/' + deptId,
    method: 'delete',
  });
}

// 修改组织信息
export function updateDept(data: any) {
  return request({
    url: '/system/dept',
    method: 'put',
    data: data,
  });
}
